<section class="format" [formGroup]="colorForm">
  <div
    [formGroup]="childForm"
    class="selectThreshold"
    *ngIf="
      chartType != 'Table' &&
      chartType != 'List' &&
      chartType != 'Pie' &&
      appliedSeries.length <= 1
    "
  >
    <mat-form-field appearance="fill" style="width: 100%">
      <mat-select
        class="filterSelect"
        appearance="fill"
        formControlName="colorType"
        placeholder="Choose Color Settings"
        floatPlaceholder="never"
        (selectionChange)="buildAggregateData()"
      >
        <mat-option value="dynamic">Dynamic</mat-option>
        <mat-option value="manual">Manual</mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <ng-container *ngIf="chartType == 'Pie'">
    <div class="subheading">Manual</div>
  </ng-container>
  <ng-container *ngIf="chartType == 'Table' || chartType == 'List'">
    <div class="subheading">Dynamic</div>
  </ng-container>

  <ng-container
    *ngIf="
      chartType != 'Table' &&
      chartType != 'List' &&
      chartType != 'Pie' &&
      appliedSeries.length > 1
    "
  >
    <div class="subheading">Manual</div>
  </ng-container>

  <div class="fieldArea">
    <ng-container *ngIf="childForm.get('colorType').value == 'dynamic'">
      <div class="thresholdLine"></div>
      <div
        class="selectFilter"
        *ngIf="filteredDataFields && filteredDataFields.length > 0"
        [formGroup]="fieldForm"
      >
        <div class="left">
          <mat-form-field appearance="fill" style="width: 100%">
            <mat-select
              class="filterSelect"
              formControlName="selectItem"
              [placeholder]="choosePlaceholder()"
              floatPlaceholder="never"
              (selectionChange)="addThreshold()"
            >
              <mat-option
                *ngFor="let item of filteredDataFields"
                [value]="item.id"
                [ngStyle]="{
                  display: isInCurrentThresholdList(item.id) ? 'none' : 'block'
                }"
              >
                {{ item.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>

      <span class="header">APPLIED COLOR SETTINGS</span>
      <ng-container *ngFor="let reportField of thresholdFields; let i = index">
        <div class="reportField-box">
          <div
            class="canvasFields"
            id="colorRight-{{ i }}"
            [ngClass]="{ selected: selectedIndex == i }"
          >
            <div class="far-left">{{ i + 1 }}.</div>
            <div class="left">
              <app-datapoint-icons
                [type]="reportField.type || reportField.dataPoint.data.type"
              ></app-datapoint-icons>
            </div>
            <div
              class="right"
              matTooltip="{{
                reportField.name || reportField.dataPoint.data.name
              }}"
              matTooltipPosition="above"
            >
              <div
                class="title"
                (click)="
                  configureFilter(
                    $event,
                    i,
                    reportField.id || reportField.dataPoint.data.id,
                    reportField,
                    false
                  )
                "
              >
                {{ reportField.name || reportField.dataPoint.data.name }}
              </div>
              <div class="type"></div>
            </div>
            <div class="far-right">
              <fa-icon
                [icon]="faEdit"
                (click)="
                  configureFilter(
                    $event,
                    i,
                    reportField.id || reportField.dataPoint.data.id,
                    reportField,
                    false
                  )
                "
                matTooltip="Configure this threshold"
                matTooltipPosition="above"
                *ngIf="reportField.id != -1"
              ></fa-icon>
              <fa-icon
                [icon]="faTrash"
                (click)="removeDataField($event, i)"
              ></fa-icon>
            </div>
          </div>
        </div>
      </ng-container>
    </ng-container>

    <ng-container *ngIf="childForm.get('colorType').value == 'manual'">
      <div
        class="thresholdLine"
        *ngIf="
          chartType != 'Table' && chartType != 'List' && chartType != 'Pie'
        "
      ></div>
      <span class="header">CHART ITEM COLORS</span>
      <ng-container
        *ngIf="
          chartType != 'Table' &&
          chartType != 'List' &&
          loadedColors &&
          isComponentOpen
        "
      >
        <ng-container *ngIf="colorFormGenerated">
          <ng-container *ngFor="let item of manualChartColors; let i = index">
            <span class="dataPointName">{{ item.value || "Empty Value" }}</span
            ><span class="dataPointColor"
              ><ngx-colors
                ngx-colors-trigger
                [hideTextInput]="true"
                [hideColorPicker]="true"
                [formControlName]="'color' + i"
                (change)="generateColors(i)"
              ></ngx-colors
            ></span>
          </ng-container>
        </ng-container>
      </ng-container>
    </ng-container>
  </div>
</section>
